import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-fund-vacation" }, null, -1)
const _hoisted_2 = { class: "col-md-9" }
const _hoisted_3 = { class: "fund-cover fund-cover__vacation d-flex align-items-start flex-column" }
const _hoisted_4 = { class: "fund-cover-header" }
const _hoisted_5 = { class: "coverage-column" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "fund-cover-row" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-receipt" }),
  /*#__PURE__*/_createElementVNode("p", { class: "links" }, [
    /*#__PURE__*/_createElementVNode("strong", null, "Contributions:")
  ])
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1)
const _hoisted_8 = { class: "fund-cover-row" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-map" }, null, -1)
const _hoisted_10 = {
  key: 0,
  class: "iatse-icon-info-circle-solid icon_rotate_0 icon_danger icon-tooltip fs-lg ml-10"
}
const _hoisted_11 = { class: "tooltip-text" }
const _hoisted_12 = { class: "fund-cover-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FundPanel = _resolveComponent("FundPanel")!

  return (_openBlock(), _createBlock(_component_FundPanel, { cardId: "card-vacation" }, {
    icon: _withCtx(() => [
      _hoisted_1
    ]),
    title: _withCtx(() => [
      _createTextVNode(" Vacation ")
    ]),
    "fund-cover": _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("p", null, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.vacationContributions?.Total), 1),
                _createElementVNode("small", null, " (" + _toDisplayString(_ctx.vacationContributions?.Label + _ctx.vacationContributions?.Date) + ")", 1)
              ])
            ]),
            _hoisted_7,
            _createElementVNode("div", {
              class: _normalizeClass(["coverage-column", {'position-relative': _ctx.vacationContributions?.Error }])
            }, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("p", {
                  class: "links text-underline plan-modal",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openModal('check-destination', 'Payment Destination Setup', 'plan-form', 'vacation')))
                }, "Vacation Check Destination")
              ]),
              _createElementVNode("p", {
                class: _normalizeClass({'text-danger': _ctx.vacationContributions?.Error })
              }, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.vacationContributions?.CheckDestination), 1),
                (_ctx.vacationContributions?.Error)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_10, [
                      _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.vacationContributions?.Error), 1)
                    ]))
                  : _createCommentVNode("", true)
              ], 2)
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              class: "btn btn-primary plan-modal",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openModal('work-history', 'Vacation Work History', '', 'vacation', null, null, undefined, { Funds: [6] })))
            }, "Work History"),
            _createElementVNode("button", {
              class: "btn btn-secondary plan-modal",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openModal('vacation', 'Vacation', 'plan-tables')))
            }, "Payment History")
          ])
        ])
      ])
    ]),
    "related-links": _withCtx(() => [
      (_ctx.vacationContributions?.IsAvailableForCheck)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn btn-tertiary btn-large plan-modal",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openModal('check-replacement', 'Check Replacement', 'plan-form', 'vacation')))
          }, " Check Replacement "))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        class: "btn btn-tertiary btn-large plan-modal",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openModal('check-destination', 'Payment Destination Setup', 'plan-form', 'vacation')))
      }, " ACH/Check "),
      _createElementVNode("a", {
        href: "",
        class: "btn btn-tertiary btn-large plan-modal",
        onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.openModal('add-beneficiary',
                'My Beneficiary(ies)',
                'plan-tables-striped beneficiary',
                null,
                null,
                null,
            )), ["prevent"]))
      }, " Beneficiary(ies) ")
    ]),
    default: _withCtx(() => [
      _createElementVNode("a", {
        href: "",
        onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.openModal('plan-resources', 'Vacation Fund Resources', null, 'vacation')), ["prevent"])),
        class: "btn btn-tertiary btn-large plan-modal"
      }, "Fund's Resources")
    ]),
    _: 1
  }))
}